"use strict";

exports.__esModule = true;
exports.default = void 0;

var _TK = _interopRequireDefault(require("./TK0"));

var _TK2 = _interopRequireDefault(require("./TK1"));

var _TK3 = _interopRequireDefault(require("./TK2"));

var _TK4 = _interopRequireDefault(require("./TK3"));

var _TK5 = _interopRequireDefault(require("./TK4"));

var _Priority = _interopRequireDefault(require("./Priority1"));

var _Priority2 = _interopRequireDefault(require("./Priority2"));

var _Priority3 = _interopRequireDefault(require("./Priority3"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "priority1": _Priority.default,
  "priority2": _Priority2.default,
  "priority3": _Priority3.default,
  "tk0": _TK.default,
  "tk1": _TK2.default,
  "tk2": _TK3.default,
  "tk3": _TK4.default,
  "tk4": _TK5.default,
  "kg0": _TK.default,
  "kg1": _TK2.default,
  "kg2": _TK3.default,
  "kg3": _TK4.default,
  "kg4": _TK5.default,
  "tg0": _TK.default,
  "tg1": _TK2.default,
  "tg2": _TK3.default,
  "tg3": _TK4.default,
  "tg4": _TK5.default
};
exports.default = _default;
module.exports = exports.default;